//1. colour to pick from
import tinycolor from 'tinycolor2';


/**
 * takes the colour from the front-end library and returns it to a state to manipulate
 * @param {*} colourObj the colour object from the front-end library
 */
export function colourPicker(colourObj){
    let colour = tinycolor(colourObj.color);
    colour.setAlpha(colourObj.alpha/100);
    if (colour.isDark) {
        // console.log("dark");
        colour = colour.spin(90);
    }
    return colour.toRgb();
}
/**
 * random colour set
 */
export function colourSet() {
    let colour = tinycolor.random().setAlpha(0.5);
    if (colour.isDark) {
        // console.log("dark");
        colour = colour.spin(90);
    }
    return colour.toRgb();

}
/**
 * this manipulates the colour depending on what sort of node type the node is
 * @param {*} parentColour colour of the parent node
 * @param {*} nodeType type of node 
 */
export function manipulateColour(parentColour, nodeType) {

    let colour = tinycolor(parentColour);
    if (nodeType === "docLib") {
        colour.lighten(15);
        let alpha = colour.getAlpha() - 0.2;
        colour.setAlpha(alpha);
        if(!colour.isDark()){
            colour.darken(25);
        }
        return colour.toRgb();

    } else if (nodeType === "site") {
        colour.darken(15);
        let alpha = colour.getAlpha() + 0.2;
        colour.setAlpha(alpha);
        if(colour.isDark()){
            colour.lighten(25);
        }
        return colour.toRgb();

    }else{
        let alpha = colour.getAlpha();
        let setAlpha;

        if(alpha > 0.3){
            setAlpha = alpha + 0.2;    
        }else{
            setAlpha = alpha - 0.2;
        }
        colour.setAlpha(setAlpha);
        return colour.toRgb();
    }

}
/**
 * helper class to turn the colour into a string for css
 * @param {} parentColour the colour objeect
 */
export function rgbString(parentColour) {
    let colour = tinycolor(parentColour);

    return colour.toRgbString();
}



// WEBPACK FOOTER //
// ./src/services/colour.js